const actionTypes = require('constants/contactCenter/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');

const agentAuthenticationLoginProgress = () => ({
    type: actionTypes.AGENT_AUTHENTICATION_REQUEST
});

const agentAuthenticationLoginSuccess = (data) => ({
    type: actionTypes.AGENT_AUTHENTICATION_SUCCESS,
    payload: data
});

const agentAuthenticationLoginFailure = (error) => ({
    type: actionTypes.AGENT_AUTHENTICATION_FAILURE,
    payload: error
});

const agentOffice = (validation) => ({
    type: actionTypes.AGENT_OFFICE_VALIDATION,
    payload: validation
});

const agentOfficeValidation = () => (dispatch, getState) => {
    const currentState = getState().agentAuthentication;
    const officeFlag = currentState.get('inOffice');

    dispatch(agentOffice(!officeFlag));
};

const agentLoginRequest = (password, user) => ( dispatch, getState ) => {
    const currentState = getState().agentAuthentication;
    const isAlreadyFetching = currentState.get('isFetching');

    if(!isAlreadyFetching) {
        const requestData = {
            query: {
                password: password,
                user: user
            }
        };

        dispatch(agentAuthenticationLoginProgress());
        return APIPost(dispatch, apiURLBuilder.getURL('agentAuthentication') ,requestData)
            .then(response => dispatch(agentAuthenticationLoginSuccess(response)))
            .catch(response => dispatch(agentAuthenticationLoginFailure(response)))
    } else {
        return Promise.resolve()
    }
};

module.exports = {
    agentLoginRequest,
    agentOfficeValidation
};
